<template>
    <NuxtLink class="v-btn" :class="classes">
        <slot></slot>
    </NuxtLink>
</template>

<script>
// This component exists because the API sometimes returns HTML with '<v-btn>'

export default {
    name: 'VBtn',
    computed: {
        classes () {
            const cls = {};
            cls['text-white no-underline'] = true;
            cls['px-4 py-3'] = true;
            cls['rounded-md shadow-sm'] = true;
            cls['focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2'] = true;
            cls['text-lg font-semibold'] = true;
            cls['bg-amber-700 text-white hover:bg-amber-600 focus-visible:outline-amber-600'] = true;
            return cls;
        }
    }
};

</script>

<style>
.block-embed-content .v-btn,
.block-embed-content .v-btn:link,
.block-embed-content .v-btn:hover,
.block-embed-content .v-btn:active,
.block-embed-content .v-btn:visited {
    @apply text-white;
    @apply no-underline;
}
</style>
